import React from 'react';
import { useSearchTab } from '../SearchTabContext';
// import SearchFlightPanel2 from '../FlightPanel/SearchFlightPanel2';
import HotelSearchPanel2 from '../HotelPanel/HotelSearchPanel2';
 
const TemplateHeroTabbedSearch2 = () => {
  const { activeTab } = useSearchTab();
  const heroConfig = {
    home: {
      image: 'https://images.unsplash.com/photo-1540541338287-41700207dee6?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=1170',
      title: 'Your Next Adventure Awaits',
      subtitle: 'Explore our curated packages.',
    },
    flights: {
      image: 'https://plus.unsplash.com/premium_photo-1661962354730-cda54fa4f9f1?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8YWlycGxhbmV8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&q=60&w=600',
      title: 'Search and Book Flights',
      subtitle: 'Find the best flight deals for your perfect trip.',
    },
    hotels: {
      image: 'https://images.pexels.com/photos/258154/pexels-photo-258154.jpeg',
      title: 'Find the Perfect Place to Stay',
      subtitle: 'Search our wide selection of hotels.',
    },
    packages: {
      image: 'https://images.pexels.com/photos/1618269/pexels-photo-1618269.jpeg',
      title: 'Discover Our Packages',
      subtitle: 'Hand-crafted itineraries for every type of traveler.',
    },
    // Add configs for about, contact, etc. if needed
  };
  const currentConfig = heroConfig[activeTab] || heroConfig.home;
  const showSearchPanel = ['flights', 'hotels'].includes(activeTab);

  return (
    <section 
      className="position-relative d-flex flex-column" // Use flex-column
      style={{
        minHeight: '90vh',
        backgroundImage: `url('${currentConfig.image}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        transition: 'background-image 0.5s ease-in-out',
      }}
    >
      <div className="position-absolute w-100 h-100 top-0 start-0" style={{ backgroundColor: 'var(--hero-overlay-color, rgba(0,0,0,0.4))' }}></div>
      
      {/* --- Main Content (Takes up the remaining space) --- */}
      <div className="container text-center text-white d-flex flex-grow-1 align-items-center justify-content-center">
          <div>
              <h1 className="display-2 fw-bold" style={{ fontFamily: 'var(--hero-title-font-family, sans-serif)',color: 'var(--hero-subtitle-color, #fffdfdff)'}}>{currentConfig.title}</h1>
              <p className="lead fs-3 mt-3" style={{ color: 'var(--hero-subtitle-color, #eee)' }}>{currentConfig.subtitle}</p>
          </div>
      </div>
      
      {/* --- Search Panel Container (At the bottom) --- */}
      {showSearchPanel && (
          <div className="container position-relative" style={{ marginBottom: '-60px', zIndex: 10 }}>
              {/* Semi-transparent background with a "frosted glass" effect */}
              <div className="rounded shadow-lg p-4" style={{ backgroundColor: 'rgba(255, 255, 255, 0.9)', backdropFilter: 'blur(10px)' }}>
                  {/* {activeTab === 'flights' && <SearchFlightPanel2/>} */}
                  {activeTab === 'hotels' && <HotelSearchPanel2 />}
              </div>
          </div>
      )}
    </section>
  );
};

export default TemplateHeroTabbedSearch2;